export default {
    "en": {
        "auth": {
            "failed": "These credentials do not match our records.",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "comments": {
            "title": "Comments",
            "table": {
                "user": "User",
                "sheet": "Sheet",
                "gis_id": "GIS ID",
                "street": "Street",
                "comment": "Comment",
                "no_comments": "No comments found."
            }
        },
        "dashboard": {
            "main": {
                "title": "Dashboard",
                "hello": "Hello, admin!"
            },
            "form": {
                "street_label": "Street",
                "street_placeholder": "Select Street",
                "house_label": "House",
                "house_placeholder": "Select House",
                "main_comment": "Main comment",
                "your_comment": "Your comment",
                "submit": "Submit",
                "form_disabled": "Admin temporarily disabled form {formName}"
            }
        },
        "filters": {
            "roles": {
                "title": "Roles",
                "all": "All",
                "admin": "Admin",
                "master": "Master",
                "supervisor": "Supervisor"
            },
            "sheets": {
                "title": "Sheets",
                "all": "Sheets"
            },
            "trashed": {
                "title": "Trashed",
                "with": "With Trashed",
                "only": "Only Trashed"
            }
        },
        "keys": {
            "title": "Keys",
            "form": {
                "user_label": "Users",
                "user_placeholder": "Select User",
                "keys_label": "Keys",
                "keys_placeholder": "Select Keys",
                "attach_keys": "Attach Keys",
                "disabled": "Admin temporarily disabled form {formName}"
            }
        },
        "keys_list": {
            "title": "Keys List",
            "table": {
                "street": "Street Name",
                "user": "User Name",
                "email": "User Email",
                "key": "Key Number",
                "no_result": "Keys for users not attached."
            }
        },
        "labels": {
            "browse": "Browse",
            "remove": "Remove",
            "error": "There is one form error.",
            "errors": "There are {count} form errors.",
            "my_profile": "My Profile",
            "logout": "Logout",
            "reset": "Reset",
            "restore": "Restore"
        },
        "login": {
            "hello": "Welcome Back!",
            "email_label": "Email",
            "password_label": "Password",
            "remember_me": "Remember Me",
            "login_button": "Login"
        },
        "main_menu": {
            "dashboard": "Dashboard",
            "users": "Users",
            "comments": "Comments",
            "sheets": "Sheets",
            "streets": "Streets",
            "jobs": "Jobs",
            "translations": "Translations",
            "keys": "Keys",
            "keys_list": "Keys List",
            "my_keys_list": "My Keys List"
        },
        "my_keys_list": {
            "title": "My Keys List",
            "key": "Key Number",
            "gis": "GIS ID",
            "street": "Street Name",
            "no_result": "You dont have any keys."
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "profile": {
            "form": {
                "first_name": "First name",
                "last_name": "Last name",
                "email": "Email",
                "password": "Password",
                "photo": "Photo",
                "button": "Update"
            }
        },
        "sheet": {
            "title": "Sheets",
            "sub_title_1": "Create",
            "sub_title_2": "Sheets",
            "table": {
                "name": "Name",
                "status": "Status",
                "update": "Update",
                "no_result": "No sheets found."
            }
        },
        "sheet_create": {
            "title_1": "Sheets",
            "title_2": "Create",
            "name": "Name",
            "is_active": "Is Active",
            "file_id": "Google File Id",
            "tab_name": "Google Sheet (Tab) Name",
            "button": "Create Sheet"
        },
        "sheet_edit": {
            "title": "Sheets",
            "deleted": "This sheet has been deleted.",
            "name": "Name",
            "is_active": "Is Active",
            "file_id": "Google File Id",
            "tab_name": "Google Sheet (Tab) Name",
            "button": "Update Sheet"
        },
        "sheets": {
            "title": "Sheets",
            "sub_title_1": "Create",
            "sub_title_2": "Sheets",
            "table": {
                "name": "Name",
                "status": "Status",
                "update": "Update",
                "no_result": "No sheets found."
            }
        },
        "street_edit": {
            "title": "Streets",
            "street_label": "Street Name",
            "button": "Update Street"
        },
        "streets": {
            "title": "Streets",
            "name": "Name",
            "sheet": "Sheet",
            "no_result": "No streets found."
        },
        "users": {
            "title": "Users",
            "create_title": "Create",
            "create_title_2": "User",
            "table": {
                "name": "Name",
                "sheet": "Sheet",
                "role": "Role",
                "count": "Count Keys",
                "email": "Email",
                "no_result": "No users found."
            }
        },
        "users_create": {
            "title_1": "Users",
            "title_2": "Users",
            "deleted": "This user has been deleted. ",
            "form": {
                "first_name": "First name",
                "last_name": "Last name",
                "email": "Email",
                "password": "Password",
                "role": "Role",
                "photo": "Photo",
                "delete": "Delete User",
                "update": "Update User",
                "sheet": "Sheet",
                "button": "Create User"
            },
            "keys": {
                "title": "User Keys",
                "delete_1": "Delete",
                "delete_2": "Keys"
            },
            "keys_table": {
                "street": "Street Name",
                "key_number": "Street Name",
                "no_keys": "For this user keys not found."
            }
        },
        "users_edit": {
            "title": "Users",
            "deleted": "This user has been deleted. ",
            "form": {
                "first_name": "First name",
                "last_name": "Last name",
                "email": "Email",
                "password": "Password",
                "role": "Role",
                "photo": "Photo",
                "delete": "Delete User",
                "update": "Update User",
                "sheet": "Sheet"
            },
            "keys": {
                "title": "User Keys",
                "delete_1": "Delete",
                "delete_2": "Keys"
            },
            "keys_table": {
                "street": "Street Name",
                "key_number": "Street Name",
                "no_keys": "For this user keys not found."
            }
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "accepted_if": "The {attribute} must be accepted when {other} is {value}.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when {other} is {value}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal to {value}.",
                "file": "The {attribute} must be greater than or equal to {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal to {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal to {value}.",
                "file": "The {attribute} must be less than or equal to {value} kilobytes.",
                "string": "The {attribute} must be less than or equal to {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} must not be greater than {max}.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "string": "The {attribute} must not be greater than {max} characters.",
                "array": "The {attribute} must not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} must be a valid URL.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            }
        }
    },
    "uk": {
        "auth": {
            "failed": "Ці облікові дані не збігаються з нашими записами",
            "password": "The provided password is incorrect.",
            "throttle": "Too many login attempts. Please try again in {seconds} seconds."
        },
        "comments": {
            "table": {
                "comment": "Коментар",
                "no_comments": "Коментарів не знайдено.",
                "sheet": "Аркуш",
                "street": "Вулиця",
                "user": "Користувач",
                "gis_id": "ID будинку"
            },
            "title": "Коментарі"
        },
        "dashboard": {
            "form": {
                "street_label": "Вулиця",
                "house_label": "Будинок",
                "street_placeholder": "Виберіть вулицю",
                "submit": "Надіслати",
                "your_comment": "Ваш коментар",
                "main_comment": "Основний коментар",
                "house_placeholder": "Виберіть будинок",
                "form_disabled": "Адміністратор тимчасово вимкнув форму коментарів"
            },
            "main": {
                "title": "Панель коментарів"
            }
        },
        "filters": {
            "roles": {
                "title": "Ролі",
                "supervisor": "Керівник",
                "master": "Майстер",
                "all": "Всі",
                "admin": "Адмін"
            }
        },
        "keys": {
            "form": {
                "attach_keys": "Видати ключі",
                "keys_label": "Видача ключів",
                "user_label": "Користувачі",
                "user_placeholder": "Виберіть Користувача",
                "keys_placeholder": "Виберіть ключі",
                "disabled": "Адміністратор тимчасово вимкнув коментарі"
            },
            "title": "Видача ключів"
        },
        "keys_list": {
            "table": {
                "email": "Email користувача",
                "key": "Номер ключа",
                "no_result": "Ключі до користувачів не додані",
                "street": "Назва вулиці",
                "user": "Ім'я користувача"
            },
            "title": "Список ключів"
        },
        "login": {
            "hello": "З поверненням!",
            "login_button": "Логін",
            "password_label": "Пароль",
            "remember_me": "Запам'ятай мене",
            "email_label": "Email пошта"
        },
        "main_menu": {
            "comments": "Comments",
            "dashboard": "Панель коментарів",
            "keys": "Видача ключів",
            "keys_list": "Список ключів",
            "my_keys_list": "Мій список ключів",
            "users": "Користувачі"
        },
        "my_keys_list": {
            "key": "Номер ключа",
            "street": "Адреса",
            "title": "Список моїх ключів",
            "no_result": "У вас немає ключів.",
            "gis": "ID будинку"
        },
        "pagination": {
            "previous": "&laquo; Previous",
            "next": "Next &raquo;"
        },
        "passwords": {
            "reset": "Your password has been reset!",
            "sent": "We have emailed your password reset link!",
            "throttled": "Please wait before retrying.",
            "token": "This password reset token is invalid.",
            "user": "We can't find a user with that email address."
        },
        "users": {
            "table": {
                "role": "Роль",
                "name": "ПІБ",
                "sheet": "Служба",
                "no_result": "Користувачів не знайдено",
                "email": "Email пошта",
                "count": "Кількість ключів"
            },
            "create_title": "Створити",
            "create_title_2": "Користувач",
            "title": "Користувачі"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted",
            "accepted_if": "The {attribute} must be accepted when {other} is {value}.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "after_or_equal": "The {attribute} must be a date after or equal to {date}.",
            "alpha": "The {attribute} must only contain letters.",
            "alpha_dash": "The {attribute} must only contain letters, numbers, dashes and underscores.",
            "alpha_num": "The {attribute} must only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "before_or_equal": "The {attribute} must be a date before or equal to {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "current_password": "The password is incorrect.",
            "date": "The {attribute} is not a valid date.",
            "date_equals": "The {attribute} must be a date equal to {date}.",
            "date_format": "The {attribute} does not match the format {format}.",
            "declined": "The {attribute} must be declined.",
            "declined_if": "The {attribute} must be declined when {other} is {value}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "dimensions": "The {attribute} has invalid image dimensions.",
            "distinct": "The {attribute} field has a duplicate value.",
            "email": "The {attribute} must be a valid email address.",
            "ends_with": "The {attribute} must end with one of the following: {values}.",
            "exists": "The selected {attribute} is invalid.",
            "file": "The {attribute} must be a file.",
            "filled": "The {attribute} field must have a value.",
            "gt": {
                "numeric": "The {attribute} must be greater than {value}.",
                "file": "The {attribute} must be greater than {value} kilobytes.",
                "string": "The {attribute} must be greater than {value} characters.",
                "array": "The {attribute} must have more than {value} items."
            },
            "gte": {
                "numeric": "The {attribute} must be greater than or equal to {value}.",
                "file": "The {attribute} must be greater than or equal to {value} kilobytes.",
                "string": "The {attribute} must be greater than or equal to {value} characters.",
                "array": "The {attribute} must have {value} items or more."
            },
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "in_array": "The {attribute} field does not exist in {other}.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "ipv4": "The {attribute} must be a valid IPv4 address.",
            "ipv6": "The {attribute} must be a valid IPv6 address.",
            "json": "The {attribute} must be a valid JSON string.",
            "lt": {
                "numeric": "The {attribute} must be less than {value}.",
                "file": "The {attribute} must be less than {value} kilobytes.",
                "string": "The {attribute} must be less than {value} characters.",
                "array": "The {attribute} must have less than {value} items."
            },
            "lte": {
                "numeric": "The {attribute} must be less than or equal to {value}.",
                "file": "The {attribute} must be less than or equal to {value} kilobytes.",
                "string": "The {attribute} must be less than or equal to {value} characters.",
                "array": "The {attribute} must not have more than {value} items."
            },
            "max": {
                "numeric": "The {attribute} must not be greater than {max}.",
                "file": "The {attribute} must not be greater than {max} kilobytes.",
                "string": "The {attribute} must not be greater than {max} characters.",
                "array": "The {attribute} must not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "mimetypes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "multiple_of": "The {attribute} must be a multiple of {value}.",
            "not_in": "The selected {attribute} is invalid.",
            "not_regex": "The {attribute} format is invalid.",
            "numeric": "The {attribute} must be a number.",
            "password": "The password is incorrect.",
            "present": "The {attribute} field must be present.",
            "prohibited": "The {attribute} field is prohibited.",
            "prohibited_if": "The {attribute} field is prohibited when {other} is {value}.",
            "prohibited_unless": "The {attribute} field is prohibited unless {other} is in {values}.",
            "prohibits": "The {attribute} field prohibits {other} from being present.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_unless": "The {attribute} field is required unless {other} is in {values}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} are present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "starts_with": "The {attribute} must start with one of the following: {values}.",
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid timezone.",
            "unique": "The {attribute} has already been taken.",
            "uploaded": "The {attribute} failed to upload.",
            "url": "The {attribute} must be a valid URL.",
            "uuid": "The {attribute} must be a valid UUID.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            }
        }
    }
}
